import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { INewUserOwnProduct } from '../../../../interfaces/OwnTractor.interfaces';
import { getNewUsersOwnProduct } from '../../../../api/product/queries/getNewUsersOwnProduct';
import { usersOwnTractorsApiUrl } from '../../../../api/product/queries/getUsersOwnTractors';

export const useGetNewUsersOwnProductQuery = () => {
  return useQuery<INewUserOwnProduct, AxiosError, INewUserOwnProduct>(
    [`${usersOwnTractorsApiUrl}/new-tractor`],
    () => getNewUsersOwnProduct(),
    {
      select: (data: INewUserOwnProduct) => {
        return {
          ...data,
          startOnSaleDate: data.registeredAt,
        };
      },
    },
  );
};
